// 월드 맵(레인 F): 필드에서 M 키·미니맵 「지도」 버튼으로 연다. 구역 6칸(지금은 1구역 이끼 유적 필드만 열림, 나머지 5구역은 잠김 표시)과
// 「마을로 귀환」. 열려 있는 동안 게임이 영웅 입력을 막는다(view.field.mapOpen). 고르기는 지금 구역뿐이라 「여기 있음」만 표시한다.
import { Scene, type GameCommand, type GameView } from '../shared/types';
import { FIELD_ZONES } from '../shared/field/layout';
import { C, FONT, el } from './dom';

export class FieldMapUi {
  private readonly root: HTMLDivElement;
  private shown = false;
  constructor(parent: HTMLElement, private readonly view: GameView, private readonly send: (c: GameCommand) => void) {
    const r = el('div', 'position:absolute;inset:0;display:none;align-items:center;justify-content:center;z-index:60;background:rgba(4,6,12,.62);font:800 14px ' + FONT + ';color:#f4ecd8;', parent);
    r.dataset.testid = 'field-worldmap';
    this.root = r;
    const box = el('div', 'width:min(620px,92vw);max-height:88vh;overflow:auto;box-sizing:border-box;padding:16px 18px;border-radius:10px;background:linear-gradient(180deg,#1a2234,#0c1220);border:2px solid #b98a2a;box-shadow:0 8px 30px rgba(0,0,0,.7);', r);
    const head = el('div', 'display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;', box);
    el('div', 'font:900 20px ' + FONT + ';color:' + C.gold + ';', head, '월드 맵');
    const close = el('button', 'font:800 14px ' + FONT + ';color:#f4ecd8;background:#2a3348;border:1px solid #b98a2a;border-radius:6px;padding:4px 12px;cursor:pointer;', head, '닫기');
    close.dataset.testid = 'field-map-close';
    close.addEventListener('click', () => send({ type: 'field', op: 'map' }));
    const grid = el('div', 'display:grid;grid-template-columns:repeat(3,1fr);gap:10px;', box);
    for (const z of FIELD_ZONES) {
      const card = el('div', 'position:relative;min-height:84px;padding:10px;border-radius:8px;box-sizing:border-box;' +
        (z.open ? 'background:linear-gradient(160deg,#2f4a2a,#1a2a18);border:2px solid #f2c14e;' : 'background:#141824;border:1.5px solid #3a4258;opacity:.62;'), grid);
      card.dataset.testid = 'field-zone-' + z.id;
      el('div', 'font:700 11px ' + FONT + ';color:#bfb59a;', card, '지역 ' + z.region);
      el('div', 'font:900 15px ' + FONT + ';margin-top:2px;color:' + (z.open ? '#fff3c8' : '#8a90a0') + ';', card, z.name);
      el('div', 'font:700 12px ' + FONT + ';margin-top:8px;color:' + (z.open ? '#9be06a' : '#8a90a0') + ';', card, z.open ? '● 여기 있음' : '🔒 잠김 · 다음 환생 콘텐츠');
    }
    const foot = el('div', 'display:flex;justify-content:flex-end;margin-top:14px;', box);
    const back = el('button', 'font:900 15px ' + FONT + ';color:#1a1206;background:linear-gradient(180deg,#f2c14e,#c8902a);border:0;border-radius:7px;padding:8px 18px;cursor:pointer;', foot, '마을로 귀환');
    back.dataset.testid = 'field-map-return';
    back.addEventListener('click', () => { send({ type: 'field', op: 'map' }); send({ type: 'field', op: 'return' }); });
    window.addEventListener('keydown', (e) => {
      if (e.code !== 'KeyM' || e.repeat || e.ctrlKey || e.metaKey || e.altKey) return;
      if (this.view.flow.scene !== Scene.Field) return;
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA')) return;
      e.preventDefault();
      send({ type: 'field', op: 'map' });
    });
  }
  update(): void {
    const v = this.view;
    const on = v.flow.scene === Scene.Field && !!v.field?.mapOpen;
    if (on !== this.shown) { this.shown = on; this.root.style.display = on ? 'flex' : 'none'; }
  }
}
